module.exports = __webpack_public_path__ + "static/media/data_science.ebf35d7f.svg";